module.exports = __webpack_public_path__ + "img/pic_grow.be361d06.png";